import {ExportActionTypes} from "./types";

import {ActionCreator, Action, Dispatch} from "redux";
import {ThunkAction} from "redux-thunk";

import {ApplicationState} from "../index";
import config from "../../config";
import { responseHandler } from "utils";

const { api } = config;
const DTS_API_STUDENT = api.DTS_API_STUDENT

export type AppThunk = ActionCreator<ThunkAction<void, ApplicationState, null, Action<string>>>;

export const exportRequest: AppThunk = (
  model: string,
  params: Record<string, any>,
  handleSuccess?: () => void,
  handleError?: () => void
) => {
  return async (dispatch: Dispatch, getState): Promise<void> => {
    const {
      auth: { token }
    } = getState();

    dispatch({ type: ExportActionTypes.POST_EXPORT_REQUEST });

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    if (token) headers.append("token", token);

    const url = `${DTS_API_STUDENT}/models/export/${model}`;

    try {
      const response = await fetch(url, {
        method: "POST", // ✅ Use POST to send body
        headers,
        body: JSON.stringify(params)
      });

      const successMessages = {
        200: {
          message: "Your export has started and will be emailed to you shortly.",
          success: true
        },
        204: {
          message: "Your export has started and will be emailed to you shortly.",
          success: true
        }
      };

      await responseHandler(
        response,
        dispatch,
        ExportActionTypes.POST_EXPORT_SUCCESS,
        ExportActionTypes.POST_EXPORT_ERROR,
        successMessages,
        handleSuccess,
        handleError
      );
    } catch (error) {
      dispatch({
        type: ExportActionTypes.POST_EXPORT_ERROR,
        payload: { message: "Export failed due to a network or server error." }
      });
      if (handleError) handleError();
    }
  };
};

export const exportListGetRequest: AppThunk = (page, size) => {
    return async (dispatch: Dispatch, getState): Promise<void> => {        
        const { auth: { token } } = getState();
        dispatch({
            type: ExportActionTypes.GET_EXPORT_HISTORY_REQUEST
        });  
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if (token) {
            headers.append('token', token);
        }
        const response = await fetch(`${DTS_API_STUDENT}/exports?page=${page}&pageSize=${size}`, {
            method: "GET",
            headers: headers,
        }).catch((error) => {
            return false;
        });
        if(typeof response === 'object' && !Array.isArray(response) && response !== null) {
            const body = await response?.json();
            const {response: response_1, body: body_1} = {response, body};
            if (!response_1.ok) {
                dispatch({
                    type: ExportActionTypes.GET_EXPORT_HISTORY_ERROR,
                    payload: body_1
                });
            } else {
                dispatch({
                    type: ExportActionTypes.GET_EXPORT_HISTORY_SUCCESS,
                    payload: body_1
                });
            }
        }
    };
};
